import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  CButton,
  CCard,
  CBadge,
  CCardBody,
  CCardTitle,
  CCardText,
  CCol,
  CRow,
  CImage,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CFormCheck,
} from '@coreui/react'
import WidgetRow from '../widgets/WidgetRow'
import {
  cilPhone,
  cilCalendarCheck,
  cilXCircle,
  cilList,
  cilArrowCircleLeft,
  cilWrapText,
  cilCart,
  cilCalendar,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import apiClient from '../../services/apiClient'
import { useNavigate } from 'react-router-dom'
import { buildApiUrl } from '../../utils/getConfiguration'
//import WidgetTop3 from '../widgets/WidgetTop3'
//import WidgetTop3Short from '../widgets/WidgetTop3Short'
import { useSwipeable } from 'react-swipeable'
//import { LocalNotifications } from '@ionic-native/local-notifications'
import { LocalNotifications } from '@capacitor/local-notifications'
import aoiPic1 from 'src/assets/devices/house.jpg'

const Calculators = () => {
  const [searchParams] = useSearchParams()
  const grp_ID = searchParams.get('grp_ID') // Hodnota z query parametrů grp_ID
  //const reminder_ID = searchParams.get('reminder_ID')
  console.log('Risks notification grp_ID ' + grp_ID)
  //console.log('Risks notification reminder_ID ' + reminder_ID)
  //const [visible, setVisible] = useState(false)
  const [recommendations, setRecommendations] = useState([])
  const [query] = useState('')
  const handlers = useSwipeable({
    onSwipedLeft: () => console.log('Swiped Left!'),
    onSwipedRight: () => console.log('Swiped Right!'),
    onSwipedUp: () => console.log('Swiped Up!'),
    onSwipedDown: () => console.log('Swiped Down!'),
  })

  const fetchRecommendationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = searchParams.get('grp_ID')
      const response = await apiClient.get(
        buildApiUrl('accountReminders', {
          account_ID,
          grp_ID,
        }),
      )
      setRecommendations(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchRecommendationsData()

    const handleNotification = (notification) => {
      const newReminderID = notification.notification?.extra?.reminder_ID
      if (newReminderID) {
        console.log('New notification received with reminder_ID:', newReminderID)
        fetchRecommendationsData()
      }
    }
    LocalNotifications.addListener('localNotificationActionPerformed', handleNotification)

    //return () => {
    //  LocalNotifications.removeAllListeners()
    //}
  })

  const filteredRecommendations =
    recommendations.length > 0 &&
    recommendations.filter((recommendation) =>
      recommendation.Title.toLowerCase().includes(query.toLowerCase()),
    )

  let navigate = useNavigate()
  const handleClickSwitchOff = async () => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('remindersStatusUpdate', {
          reminder_ID,
          state: 'S',
          account_ID,
        }),
      )
      //window.location.reload()
      fetchRecommendationsData()
      window.location.href = '/'
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleClickIgnore = async () => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('remindersStatusUpdate', {
          reminder_ID,
          state: 'I',
          account_ID,
        }),
      )
      //window.location.reload()
      fetchRecommendationsData()
      window.location.href = '/'
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleClickDone = async () => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('remindersStatusUpdate', {
          reminder_ID,
          state: 'D',
          account_ID,
        }),
      )
      //window.location.reload()
      fetchRecommendationsData()
      window.location.href = '/'
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }
  const handleClickPostpone = async () => {
    try {
      const reminder_ID = localStorage.getItem('taskid')
      const expecteddate = localStorage.getItem('AImonth')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('remindersDueDateUpdate', {
          reminder_ID,
          expecteddate,
          account_ID,
        }),
      )
      //window.location.reload()
      fetchRecommendationsData()
      window.location.href = '/'
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  return (
    <>
      <CCard className="mb-4">
        <div style={{ color: 'white' }}>.</div>
        <div style={{ color: 'white' }}>.</div>
        <CCardBody>
          <CCol sm={12}>
            <h4 id="traffic" className="card-title mb-0">
              <p id="caption 2">Calculators</p>
            </h4>
          </CCol>
          <hr></hr>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                //localStorage.removeItem('loginName1')
                //localStorage.removeItem('wizard')
                console.log('Back')
                //window.history.back()
                window.location.href = '/'
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
      <CCard className="mb-4" {...handlers}>
        <CCardBody>
          <CRow>
            <CCol>
              <div key={1}>
                <CCard key={1} sm={2} className="mb-4" color="light">
                  <CCardBody>
                    <CRow className="align-items-start">
                      <CCol xs={3} sm={2} md={2} lg={2} xl={2} xxl={2}>
                        {/*<CCardImage orientation="top" src={avatar2} />*/}
                        <img
                          src={aoiPic1}
                          className="rounded-circle"
                          height={100}
                          width={100}
                        ></img>
                      </CCol>
                      <CCol xs={3} sm={6} md={6} lg={6} xl={6} xxl={6}>
                        <CCardText>Room</CCardText>
                      </CCol>
                      <CCol xs={6} sm={3} md={3} lg={3} xl={3} xxl={3}>
                        <CCardText>Consumption</CCardText>
                      </CCol>
                      <hr />
                      <CCol xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                        <WidgetRow />
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCard>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardBody>
          <CCol sm={12}>
            <CButton
              color="primary"
              onClick={() => {
                console.log('Back')
                //window.history.back()
                window.location.href = '/'
              }}
            >
              <CIcon icon={cilArrowCircleLeft} size="xxl" />
            </CButton>
          </CCol>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Calculators
